export interface JsonLdScriptProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  schema: { "@type": string | string[]; [key: string]: any };
  id?: string;
}

export function JsonLdScript({ schema, id }: JsonLdScriptProps) {
  const schemaType = schema["@type"];
  const key = id ?? `schema-${Array.isArray(schemaType) ? schemaType[0] : schemaType}`;

  return (
    <script
      key={key}
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema, null, 0),
      }}
    />
  );
}
